/**
 *  Mixin File
 */
import { mapGetters } from "vuex"
import { RepositoryFactory } from "../repositories/RepositoryFactory"
import Repository from "../repositories/Repository"
import authService from "../components/login/utils/auth"

const UserRepository = RepositoryFactory.get("user")
const PostRepository = RepositoryFactory.get("posts")
const AppRepository = RepositoryFactory.get("app")

// import { eventBus } from '../main'

export default {
  computed: {
    ...mapGetters({
      currentCircle: "Circle/currentCircle",
      mobileSideMenuClicked: "Circle/mobileSideMenuClicked",
      authUser: "User/user",
      viewUser: "User/viewUser",
      isLoading: "App/isLoading",
      isFetchingStoreData: "Signup/isFetchingStoreData",
    }),
  },

  methods: {
    markAsClicked(reactionType, reactedOnType, reactedOnId) {
      const payload = {
        reacted_on_type: reactedOnType,
        reacted_on_id: reactedOnId,
        user: this.authUser.user.id,
        reaction_type: reactionType,
      }
      PostRepository.saveReaction(this.currentCircle.id, payload)
        .then(res => null)
        .catch(err => null)
    },

    notify(type, title = "Success", description = "Sent successfully.") {
      this.$notification[type]({ message: title, description: description })
    },

    /**
     *
     * Get Auth User role
     */
    getAuthUserRole() {
      return this.authUser.user.role
    },

    /**
     *
     * Get Auth User initials
     */
    getAuthUserInitials() {
      let f = "",
        l = ""
      if (this.authUser.user.role === "patient" || this.authUser.user.role === "caregiver") {
        f = this.authUser.user.display_name ? this.authUser.user.display_name[0].toUpperCase() : "D"
      } else {
        f = this.authUser.user.first_name
          ? this.authUser.user.first_name[0].toUpperCase()
          : this.authUser.user.display_name
          ? this.authUser.user.display_name[0].toUpperCase()
          : this.authUser.user.email
          ? this.authUser.user.email[0].toUpperCase()
          : "D"
        l = this.authUser.user.last_name ? this.authUser.user.last_name[0].toUpperCase() : ""
      }
      return f + l
    },

    /**
     * Check if user is a doctor
     */
    isDoctor() {
      return this.authUser.user.role === "doctor" || this.authUser.user.role === "hospital_administrator" || this.authUser.user.role === "clinic_administrator" || this.authUser.user.role === "nfp"
    },

    displayHowAreYouFeeling() {
      return this.authUser.user.role === "patient" || this.authUser.user.role === "caregiver"
    },

    showReviewButton(type) {
      //
      const types = ["hospital_administrator", "clinic_administrator", "nfp", "ohcp", "doctor", "advocate"]
      return !types.includes(type)
    },

    /**
     * Set app loader Status
     *
     * @param {boolean} status
     */
    setAppLoaderStatus(status) {
      this.$store.commit("App/setLoading", { data: status })
    },

    getRquestToAddText(status) {
      switch (status) {
        case true:
          return null
        case false:
          return "REQUEST TO ADD"
        case "pending":
          return "REQUESTED"
        default:
          break
      }
    },

    hasMultiRole(id) {
      AppRepository.getHasMultiRole(id)
        .then(res => {
          console.log(res, "multirole")
          // if (res.data.data.length<1) {
          //   return false
          // } else {
          //   return true
          // }
        })
        .catch(err => {})
    },

    viewProfile(user) {
      // console.log("== viewProfile ==");
      // console.log("user is === ",user);
      this.$store.commit("User/setViewUser", { data: { ...this.viewUser, isDirectory: false } })
      if (user.id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        switch (user.role) {
          case "doctor":
            this.$router.push({
              name: "ViewDoctorUpdates",
              params: { id: user.id },
            })
            break
          case "clinic_administrator":
            this.$router.push({
              name: "ViewClinicAbout",
              params: { id: user.id },
            })
            break
          case "hospital_administrator":
            this.$router.push({
              name: "ViewHos_adminAbout",
              params: { id: user.id },
            })
            break
          case "nfp":
            this.$router.push({
              name: "ViewNfpAbout",
              params: { id: user.id },
            })
            break
          case "patient":
            this.$router.push({
              name: "ViewPatientUpdates",
              params: { id: user.id },
            })
            break
          case "caregiver":
            this.$router.push({
              name: "ViewPatientUpdates",
              params: { id: user.id, role: "caregiver" },
            })
            break
          case "advocate":
            this.$router.push({
              name: "ViewAdvocateAbout",
              params: { id: user.id },
            })
            break
          case "hospital":
            this.$router.push({
              name: "HospViewAbout",
              params: { id: user.id },
            })
            break
          case "clinic":
            this.$router.push({
              name: "ClinicViewAbout",
              params: { id: user.id },
            })
          case "nfp_administrator":
            this.$router.push({
              name: "ViewNfpAdminAbout",
              params: { id: user.id },
            })
            break
          case "hcp":
            this.$router.push({
              name: "ViewHcpAbout",
              params: { id: user.id },
            })
            break
          default:
            break
        }
      }
    },

    viewEntityProfile(user) {
      // console.log("== viewEntityProfile ==");
      switch (user.role) {
        case "doctor":
          this.$router.push({
            name: "ViewDoctorAbout",
            params: { id: user.ext_ref_id ? user.ext_ref_id : user.id },
            query: { isDirectory: true },
          })
          this.$router.go()
          break
        case "hcp":
          this.$router.push({
            name: "ViewHcpAbout",
            params: { id: user.ext_ref_id ? user.ext_ref_id : user.id },
            query: { isDirectory: true },
          })
          break
        case "hospital":
          this.$router.push({
            name: "HospViewAbout",
            params: { id: user.ext_ref_id ? user.ext_ref_id : user.id },
          })
          this.$router.go()
          break
        case "clinic":
          this.$router.push({
            name: "ClinicViewAbout",
            params: { id: user.ext_ref_id ? user.ext_ref_id : user.id },
          })
          break
        case "nfp":
          this.$router.push({
            name: "ViewNfpAbout",
            params: { id: user.ext_ref_id ? user.ext_ref_id : user.id },
          })
          break
        default:
          break
      }
    },

    routeToAuthProfile(profileType) {
      switch (profileType) {
        case "patient":
          this.$router.push({ name: "PatientUpdates" })
          break
        case "caregiver":
          this.$router.push({ name: "CaregiverUpdates" })
          break
        case "advocate":
          this.$router.push({ name: "AdvocateUpdates" })
          break
        case "doctor":
          this.$router.push({ name: "DocUpdates" })
          break
        default:
          this.$router.push({ name: "DocUpdates" })
          break
      }
    },
    /**
     * Logout
     */

    logout() {
      console.log("mixin -> Logout() called")
      authService.methods.logout().then(res => {
        this.$store.dispatch("Auth/logout").then(() => {
          // eventBus.$emit('refreshCircle')
          // this.$router.push({ name: 'Login' })

          console.log("newLogout api")
          UserRepository.recordLogout().then(res => {
            this.$router.push({ name: "AllCircles" })
            location.reload()
          })
        })
      })
    },
    /**
     * Get currently selected circle
     */
    getCurrentlySelectedCircle() {
      return JSON.parse(localStorage.getItem("currentCircle"))
    },

    /**
     * Get Primary 500 Color
     */
    getPrimaryColor() {
      return this.currentCircle ? `${this.currentCircle.color_code} !important` : this.getPrimaryFallbackColor()
    },

    /**
     * Get Primary 50 Color
     */
    getPrimary50Color() {
      return this.currentCircle ? (this.currentCircle.color_code50 ? `${this.currentCircle.color_code50} !important` : "#E1EAF7 !important") : "#E1EAF7 !important"
    },

    /**
     * Get Primary 300 Color
     */
    getPrimary300Color() {
      return this.currentCircle ? (this.currentCircle.color_code300 ? `${this.currentCircle.color_code300} !important` : "#A1BDE5 !important") : "#A1BDE5 !important"
    },

    /**
     * Get Primary 700 Color
     */
    getPrimary700Color() {
      return this.currentCircle ? (this.currentCircle.color_code700 ? `${this.currentCircle.color_code700} !important` : "#E1EAF7 !important") : "#E1EAF7 !important"
    },

    /**
     * Get Secondary 900 Color
     */
    getSecondaryColor() {
      return this.currentCircle ? `${this.currentCircle.color_code2} !important` : "#062B54 !important"
    },

    /**
     * Get notifications 500 Color
     */
    getNotification500Color() {
      return this.currentCircle ? `${this.currentCircle.color_code3} !important` : this.getPrimaryFallbackColor()
    },

    /**
     * Get Primary Circle Color with opacity 30%
     */
    getAlphaPrimaryColor() {
      const curr_color = this.currentCircle ? this.currentCircle.color_code : this.getPrimaryFallbackColor()
      let color
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(curr_color)) {
        color = curr_color.substring(1).split("")
        if (color.length == 3) {
          color = [color[0], color[0], color[1], color[1], color[2], color[2]]
        }
        color = "0x" + color.join("")
        return "rgba(" + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(",") + ",.3) !important"
      }
    },

    /**
     * Get Primary Circle Color with opacity 50%
     */
    getAlphaPrimaryColor50() {
      const curr_color = this.currentCircle ? this.currentCircle.color_code : this.getPrimaryFallbackColor()
      let color
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(curr_color)) {
        color = curr_color.substring(1).split("")
        if (color.length == 3) {
          color = [color[0], color[0], color[1], color[1], color[2], color[2]]
        }
        color = "0x" + color.join("")
        return "rgba(" + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(",") + ",.5) !important"
      }
    },

    /**
     * Get active link style
     */
    getActiveLinkStyle() {
      return `color:${this.getPrimaryColor()}`
    },

    /**
     * Get Primary Fallback Color
     */
    getPrimaryFallbackColor() {
      return "#2A71D4 !important"
      // return "#0E72BA !important"
    },

    getCorrectChoiceColor() {
      return "#34D230"
    },

    /**
     * Get a Random Color from the List
     */
    getRandomColor() {
      const colors = ["#EF8585", "#F4B070", "#DACE5F", "#AACD78", "#E195D8", "#BF9CE3", "#649BD1", "#64BED1"]
      return colors[Math.floor(Math.random() * (colors.length + 1))]
    },

    /**
     * Get a Random Color mapped to user id from the List
     *
     * @param id number
     *
     */
    getAvatarColor(id = 0) {
      const colors = ["#EF8585", "#F4B070", "#DACE5F", "#AACD78", "#E195D8", "#BF9CE3", "#649BD1", "#64BED1"]
      return colors[id % colors.length]
    },

    /**
     * Format datetime to human redeable format
     *
     * @param String value
     */
    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return ["a few seconds ago", "today"]
      } else if (seconds <= 90) {
        return ["a minute ago", "today"]
      } else if (minutes <= 45) {
        return [minutes + " minutes ago", "today"]
      } else if (minutes <= 90) {
        return ["an hour ago", "today"]
      } else if (hours <= 22) {
        return [hours + " hours ago", "today"]
      } else if (hours <= 36) {
        return ["a day ago", false]
      } else if (days <= 25) {
        return [days + " days ago", false]
      } else if (days <= 45) {
        return ["a month ago", false]
      } else if (days <= 345) {
        return [months + " months ago", false]
      } else if (days <= 545) {
        return ["a year ago", false]
      } else {
        // (days > 545)
        return [years + " years ago", false]
      }
    },

    getReviewInputPlaceholder(type) {
      switch (type) {
        case "hospital_administrator":
        case "hospital":
          return "I have been visiting this hospital once a month and I have developed a great relationship. Hospital staff are attentive, understanding and answers any questions I have. I highly recommend this hospital."
        case "clinic_administrator":
        case "clinic":
          return "I have been visiting this clinic once a month and I have developed a great relationship. Clinic staff are attentive, understanding and answers any questions I have. I highly recommend this clinic."
        case "doctor":
        case "physician":
          return "Ex: I have been seeing this doctor regularly and we have developed a great relationship. He is attentive, understanding and answers any questions i have. I highly recommended this doctor."
        case "hcp":
        case "ohcp":
        case "other":
          return "Ex: I have been seeing this practice provider regularly and we have developed a great relationship. He is attentive, understanding and answers any questions i have. I highly recommended this practice provider."
        case "medication":
          return "I have been prescribed this medication for the last six months and find it to be fairly effective for my condition. So far, I have felt only some mild side effects."
        default:
          return ""
      }
    },

    hideNotiUser(notiText) {
      let hide = false
      const hiddenWords = ["flaged", "report", "moderation", "acceptable", "removed"]
      hiddenWords.forEach(word => {
        if (notiText.includes(word)) {
          hide = true
          return
        }
      })
      return hide
    },

    getNewNotificationText(oldNotiText, s_user, s_role, s_gender, r_role) {
      switch (oldNotiText) {
        case "added you to circle":
          // return `${["doctor", "physician", "hcp", "ahcp", "ohcp", "other"].includes(s_role.toLowerCase()) ? "Doctor" : ""} ${user} added you to
          // ${["doctor", "physician", "hcp", "ahcp", "ohcp", "other"].includes(s_role.toLowerCase()) ? (["male", "m"].includes(s_gender.toLowerCase()) ? "his" : "hers") : "their"} circle`
          // return `added you to ${["doctor", "physician"].includes(s_role.toLowerCase()) ? (["male", "m"].includes(s_gender.toLowerCase()) ? "his" : "hers") : "their"} circle`
          return `added you to ${s_gender ? (["male", "m"].includes(s_gender.toLowerCase()) ? "his" : "hers") : "their"} circle`

        // case "commented on your poll":
        // case "commented on your job":
        // case "commented on your event":
        // case "commented on your post":
        // case "commented on your press release":
        //   return "commented on your post"

        // case "liked your poll":
        // case "liked your post":
        // case "liked your job":
        // case "liked your event":
        // case "liked your press release":
        // case "liked your question":
        //   return `liked your post`

        case "hugged your question":
        case "hugged your post":
        case "hugged your poll":
        case "hugged your job":
        case "hugged your event":
        case "hugged your press release":
          return `embraced you`

        case "reacted haha on poll":
        case "reacted haha on job":
        case "reacted haha on event":
        case "reacted haha on press release":
        case "reacted haha on post":
        case "reacted haha on question":
          return `found your ${oldNotiText.split("on ")[1]} funny`
        // return `found your post funny`

        case "reacted angry on poll":
        case "reacted angry on post":
        case "reacted angry on event":
        case "reacted angry on job":
        case "reacted angry on press release":
        case "reacted angry on question":
          return `was angry with your ${oldNotiText.split("on ")[1]}`

        case "reacted sad on poll":
        case "reacted sad on post":
        case "reacted sad on job":
        case "reacted sad on press release":
        case "reacted sad on event":
        case "reacted sad on question":
          return `found your ${oldNotiText.split("on ")[1]} emotional`

        case "commented on your comment":
          return "replied to your comment"

        // case "reviewed you":
        //   return "reviewed you"

        // case "recommended you":
        //   return "recommended you"

        case "said hi to you":
          return "Sent you a message"

        case "commented on your question":
          return "answered your question"

        // case "marked as useful on your comment":
        //   return `marked your answer as useful`

        case "marked as useful on your comment":
          return `${["doctor", "physician"].includes(r_role.toLowerCase()) && ["doctor", "physician"].includes(s_role.toLowerCase()) ? "agrees to your answer" : "marked your answer as useful"} `

        // case "":
        //   return "agrees to your answer"

        case "":
          return "replied to your review"

        case "flaged your event":
        case "flaged your comment":
        case "flaged your post":
        case "flaged your job":
        case "flaged your poll":
        case "flaged your question":
        case "flaged your press release":
          // return (
          //   "Reported " +
          //   oldNotiText
          //     .split(" ")
          //     .slice(1)
          //     .join(" ")
          // )
          // return "Reported your comment"
          return `${oldNotiText
            .split(" ")
            .slice(1)
            .join(" ")} has been reported`

        case "":
          return "Your comment/post is under moderation"

        case "Your comment/post was found acceptable":
          return "Your comment/post was found acceptable"

        case "Your comment/post has been removed":
          return "Your comment/post has been removed"

        case "The comment/post you reported was found acceptable":
          return "The comment/post you reported was found acceptable"

        case "":
          return "The comment/post you reported has been removed"

        default:
          return oldNotiText
      }
    },

    getCoreReviewApiRole(role) {
      switch (role) {
        case "doctor":
        case "physician":
          return "physician"
        case "ohcp":
        case "hcp":
        case "ahcp":
        case "other":
          return "ohcp"
        case "clinic":
        case "clinic_administrator":
          return "clinic"
        case "hospital":
        case "hospital_administrator":
          return "hospital"
        default:
          return role
      }
    },

    hasCoreReviews(role) {
      switch (role) {
        case "doctor":
        case "physician":
        case "ohcp":
        case "hcp":
        case "ahcp":
        case "other":
        case "clinic":
        case "clinic_administrator":
        case "hospital":
        case "hospital_administrator":
          return true
        default:
          return false
      }
    },

    canReview(role) {
      if (["nfp", "nfp_administrator"].includes(role)) {
        return false
      }
      if (["patient", "caregiver", "advocate"].includes(this.authUser.user.role)) {
        return true
      }
      return false
    },

    canAgree(role) {
      const ALLOWED_ROLES = ["doctor", "physician", "other", "hcp", "app", "ohcp", "ahcp"]
      // return ALLOWED_ROLES.includes(role) && ALLOWED_ROLES.includes(this.authUser.user.role)
      return ALLOWED_ROLES.includes(this.authUser.user.role)
    },

    getOS() {
      const userAgent = navigator.userAgent || window.opera
      if (/android/i.test(userAgent)) {
        return "Android"
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS"
      }
    },

    isDateToday(date) {
      const now = new Date()
      if (date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()) {
        return true
      }
      return false
    },

    getRoleName(role) {
      switch (role) {
        case "app":
        case "hcp":
        case "ahcp":
        case "ohcp":
        case "other":
          return "Advanced Practice Provider"
        case "doctor":
          return "Physician"
        case "nfp_administrator":
          return "Non For Profit"
        case "clinic_administrator":
          return "Clinic"
        case "hospital_administrator":
          return "Hospital"
        case "business_administrator":
          return "Business"
        default:
          return role
      }
    },

    formatDate(date, formatString = "D MMM YYYY") {
      return this.moment(date).format(formatString)
    },

    getDovemedPostApiIdName(type = "") {
      switch (type.toLowerCase()) {
        case "poll":
          return "poll_id"
        case "question":
          return "question_id"
        case "job":
          return "jobs_id"
        case "event":
          return "evnt_id"
        case "press":
        case "press release":
        case "pressrelease":
          return "press_release_id"
        default:
          return "id"
      }
    },

    getFrequencyName(id) {
      switch (id.toLowerCase()) {
        case "twice":
          return "Twice a day"
        case "once":
          return "Once a day"
        case "week":
          return "Weekly"
        case "month":
          return "Monthly"
        default:
          return ""
      }
    },

    getAbbreviatedUSState(state) {
      const states = {
        Alabama: "AL",
        Alaska: "AK",
        Arizona: "AZ",
        Arkansas: "AR",
        California: "CA",
        Colorado: "CO",
        Connecticut: "CT",
        Delaware: "DE",
        Florida: "FL",
        Georgia: "GA",
        Hawaii: "HI",
        Idaho: "ID",
        Illinois: "IL",
        Indiana: "IN",
        Iowa: "IA",
        Kansas: "KS",
        Kentucky: "KY",
        Louisiana: "LA",
        Maine: "ME",
        Maryland: "MD",
        Massachusetts: "MA",
        Michigan: "MI",
        Minnesota: "MN",
        Mississippi: "MS",
        Missouri: "MO",
        Montana: "MT",
        Nebraska: "NE",
        Nevada: "NV",
        "New Hampshire": "NH",
        "New Jersey": "NJ",
        "New Mexico": "NM",
        "New York": "NY",
        "North Carolina": "NC",
        "North Dakota": "ND",
        Ohio: "OH",
        Oklahoma: "OK",
        Oregon: "OR",
        Pennsylvania: "PA",
        "Rhode Island": "RI",
        "South Carolina": "SC",
        "South Dakota": "SD",
        Tennessee: "TN",
        Texas: "TX",
        Utah: "UT",
        Vermont: "VT",
        Virginia: "VA",
        Washington: "WA",
        "West Virginia": "WV",
        Wisconsin: "WI",
        Wyoming: "WY",
      }

      return states[state]
    },

    muteUser(c_id, other) {
      UserRepository.muteUser({ user_circle: c_id, user_id: other.id, role: other.role })
        .then(res => {
          this.$notification.success({ message: "Muted", description: "This user has been muted successfully" })
          this.$router.push({ name: "ActivityHome" })
        })
        .catch(e => {
          this.$notification.error({ message: "Error", description: "Cannot mute user" })
        })
    },

    // goToSSO() {
    //   window.location.href = `${process.env.SSO_BASE_URL}/dovemed-sso?next=${process.env.SSO_BASE_URL}/mycircles`
    // },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/mixin.js